import * as types from './actionTypes';

// ─────────────────────────────
// FETCH LESSONS
// ─────────────────────────────
export const fetchLessonsRequest = (params = {}) => ({
  type: types.FETCH_LESSONS_REQUEST,
  payload: params,
});

export const fetchLessonsSuccess = (data) => ({
  type: types.FETCH_LESSONS_SUCCESS,
  payload: data,
});

export const fetchLessonsFailure = (error) => ({
  type: types.FETCH_LESSONS_FAILURE,
  payload: error,
});

// ─────────────────────────────
// ADD LESSON
// ─────────────────────────────
export const addLessonRequest = (data, callback) => ({
  type: types.ADD_LESSON_REQUEST,
  payload: { data, callback },
});

export const addLessonSuccess = (data) => ({
  type: types.ADD_LESSON_SUCCESS,
  payload: data,
});

export const addLessonFailure = (error) => ({
  type: types.ADD_LESSON_FAILURE,
  payload: error,
});

// ─────────────────────────────
// UPDATE LESSON
// ─────────────────────────────
export const updateLessonRequest = (id, data, callback) => ({
  type: types.UPDATE_LESSON_REQUEST,
  payload: { id, data, callback },
});

export const updateLessonSuccess = (data) => ({
  type: types.UPDATE_LESSON_SUCCESS,
  payload: data,
});

export const updateLessonFailure = (error) => ({
  type: types.UPDATE_LESSON_FAILURE,
  payload: error,
});

// ─────────────────────────────
// DELETE LESSON
// ─────────────────────────────
export const deleteLessonRequest = (id) => ({
  type: types.DELETE_LESSON_REQUEST,
  payload: id,
});

export const deleteLessonSuccess = (data) => ({
  type: types.DELETE_LESSON_SUCCESS,
  payload: data,
});

export const deleteLessonFailure = (error) => ({
  type: types.DELETE_LESSON_FAILURE,
  payload: error,
});
